import { FC } from 'react';
import ConfirmationDialog from 'components/ConfirmationDialog/ConfirmationDialog';

interface Props {
  visible: boolean;
  onClose: () => void;
  onRemove: () => void;
}

const RemoveCustomSection: FC<Props> = (props: Props) => {
  const { visible, onClose, onRemove } = props;

  return (
    <ConfirmationDialog
      title="Remove"
      visible={visible}
      onCancel={onClose}
      onOk={onRemove}
      okText="Remove Section"
      cancelText="Cancel"
      isCancelLink={true}
      flipFooterOrder={true}
      width="465px"
    >
      <div>
        <p>
          Are you sure you want to remove this section? It will be immediately
          removed from this page layout.
        </p>
      </div>
    </ConfirmationDialog>
  );
};

export default RemoveCustomSection;
